// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2GlhG","empty":"ModalGraph_empty__dh7gC"};